import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn.ts';
import { GlassRegular } from './GlassSurface/index.ts';

const cardVariants = cva('rounded-xl', {
    variants: {
        variant: {
            default: 'card-shadow bg-white dark:bg-surface-dark',
            flat: 'bg-gray-50 dark:bg-white/5',
            outlined: 'border border-gray-200 bg-white dark:border-border-dark dark:bg-surface-dark',
            elevated: 'card-shadow bg-surface-dark dark:bg-surface-dark',
            glass: '',  // Styling delegated to GlassRegular wrapper
        },
        padding: {
            none: '',
            sm: 'p-3',
            md: 'p-5',
            lg: 'p-8',
        },
    },
    defaultVariants: {
        variant: 'default',
        padding: 'md',
    },
});

export interface CardProps
    extends Omit<React.HTMLAttributes<HTMLDivElement>, 'onClick' | 'onKeyDown' | 'role' | 'tabIndex'>,
        VariantProps<typeof cardVariants> {
}

export const Card: React.FC<CardProps> = ({
    children,
    className,
    variant,
    padding,
    ...props
}) => {
    const {
        onClick: _onClick,
        onKeyDown: _onKeyDown,
        role: _role,
        tabIndex: _tabIndex,
        interactive: _interactive,
        ariaLabel: _ariaLabel,
        ...passiveProps
    } = props as typeof props & {
        onClick?: unknown;
        onKeyDown?: unknown;
        role?: unknown;
        tabIndex?: unknown;
        interactive?: unknown;
        ariaLabel?: unknown;
    };

    if (variant === 'glass') {
        return (
            <GlassRegular
                className={cn(
                    'rounded-xl',
                    padding === 'none' ? '' : padding === 'sm' ? 'p-3' : padding === 'lg' ? 'p-8' : 'p-5',
                    className
                )}
                {...passiveProps}
            >
                {children}
            </GlassRegular>
        );
    }

    return (
        <div 
            className={cn(
                cardVariants({ variant, padding }),
                className
            )}
            {...passiveProps}
        >
            {children}
        </div>
    );
};














